import type { InputHTMLAttributes } from 'react';
import { sanitizePhone } from './inputMask';

type PhoneInputProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'value' | 'onChange' | 'type'
> & {
  value: string;
  onChange: (value: string) => void;
};

/**
 * Controlled phone-number input: opens the telephone keypad on mobile
 * (`type="tel"` + `inputMode="tel"`) and allows digits, spaces, and a single
 * leading `+` for foreign country codes. All other input attributes pass
 * through.
 */
export default function PhoneInput({ value, onChange, ...rest }: PhoneInputProps) {
  return (
    <input
      {...rest}
      type="tel"
      inputMode="tel"
      value={value}
      onChange={(e) => onChange(sanitizePhone(e.target.value))}
    />
  );
}
